<template>
  <v-dialog fullscreen v-model="dialog" transition="dialog-bottom-transition">
    <v-card v-if="user">
      <item-fullscreen-toolbar :title="user.name" :mdate="user.mdate" close-route="usersList">
        <template slot="icon">
          <v-avatar>
            <img :src="user.picture" />
          </v-avatar>
        </template>
        <template slot="badges">
          <user-status :enabled="user.app_metadata ? user.app_metadata.enabled : false" />
        </template>
      </item-fullscreen-toolbar>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex md8 lg4>
            <v-form v-model="validUser" ref="form">
              <v-alert class="mb-4" type="warning" :value="true">
                {{ $t('utenti.item.warning') }}
              </v-alert>
              <v-select
                v-model="user.app_metadata.roles"
                :label="$t('utenti.item.ruoli')"
                multiple
                clearable
                @change="rolesChanged"
                :rules="[$validate.isNotAnEmptyArray]"
                :items="roles"
              >
                <template slot="selection" slot-scope="data">
                  <v-chip label small close @input="removeRole(data.item)">
                    {{ data.item }}
                  </v-chip>
                </template>
              </v-select>
              <v-select
                v-if="user.app_metadata.langs"
                v-model="user.app_metadata.langs"
                :items="langs"
                :rules="[$validate.isNotAnEmptyArray]"
                required
                multiple
                @change="delete user.app_metadata.default_lang"
                :label="$t('utenti.item.lingue')"
              />
              <v-radio-group
                :label="$t('utenti.item.lingua')"
                mandatory
                v-if="user.app_metadata.langs"
                :rules="[$validate.required]"
                v-model="user.app_metadata.default_lang"
              >
                <v-radio
                  color="primary"
                  v-for="lang in langs"
                  :key="lang.value"
                  :label="lang.text == 'Italiano'? $t('utenti.item.italiano') : $t('utenti.item.inglese')"
                  :value="lang.value"
                  :disabled="user.app_metadata.langs.indexOf(lang.value) === -1"
                />
              </v-radio-group>
              <federation-selection
                :disabled="user.app_metadata.roles.indexOf('admin') !== -1"
                :component="'user'"
                v-model="user.app_metadata.tenants"
                :label="$t('utenti.item.tenant')"
              />
              <v-switch color="info" :label="$t('utenti.item.abilitato')" v-model="user.app_metadata.enabled" />
              <v-switch color="info" :label="$t('utenti.item.primo')" v-model="user.user_metadata.firstLogin" />
            </v-form>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md8 lg4>
            <v-btn class="ml-0" color="primary" @click="save" :disabled="!validUser">{{ $t('utenti.item.salva') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { $EventBus } from '@/eventBus';
import itemFullscreenToolbar from '@/components/common/ItemFullscreenToolbar';
import federationSelection from '@/components/common/FederationSelection';
import userStatus from '@/components/users/UserStatus';
export default {
  data: () => ({
    user: null,
    dialog: null,
    validUser: false,
    roles: [
      'admin', // eh già
      'news', // pubblica notizie
      'news_lock', // può bloccare l'editing di una news
      'meta', // compila i meta negli item
      'media', // gestisce i media
      'media_readonly', // vede i media
      'users', // gestisce gli utenti
      'corsi', // accede alla gestione corsi
      'procedure', // gestisce i dati di procedure,
      'tenants', // gestisce i tenant
    ],
    langs: [
      {
        text: 'Italiano',
        value: 'it',
      },
      {
        text: 'Inglese',
        value: 'en',
      },
    ],
  }),
  components: {
    itemFullscreenToolbar,
    federationSelection,
    userStatus,
  },
  methods: {
    removeRole(role) {
      const index = this.user.app_metadata.roles.indexOf(role);
      if (index !== -1) {
        this.user.app_metadata.roles.splice(index, 1);
      }
    },
    rolesChanged(roles) {
      if (roles.indexOf('admin') !== -1) {
        // se metto admin, non hanno senso i tenants
        this.user.app_metadata.tenants.splice(0, this.user.app_metadata.tenants.length);
      }
    },
    save() {
      this.$http
        .put('/users', this.user)
        .then(() => {
          this.dialog = null;
          this.$router.push({ name: 'usersList' });
          $EventBus.$emit('message', { type: 'success', text: this.$t('success.users.update') });
        })
        .catch((err) => {
          console.error(err);
          $EventBus.$emit('message', { type: 'error', text: this.$t('error.users.update') });
        });
    },
  },
  mounted() {
    this.$http
      .get(`/users/${this.$route.params.id}`)
      .then((response) => {
        const user = response.data;
        if (!user.app_metadata) {
          user.app_metadata = {
            // al primo accesso mancano
            roles: [],
            tenants: [],
            langs: [],
            default_lang: null,
          };
        }
        this.user = user;
        this.dialog = true;
      })
      .catch((err) => {
        console.error(err);
        $EventBus.$emit('message', { type: 'error', text: this.$t('error.users.recover') });
      });
  },
};
</script>
